import { Cookie } from "@xt/xtbase";

export const SITE_CLIENT_CODE_COOKIE = "clientCode";
export const BEHAVIOR_TRACKER_CLIENT_CODE_KEY = "__behavior_tracker_client_code__";

function generateNonceStr(length) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < (length || 32); i += 1) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

/** 与全站 API Header client-code 保持一致（32 位） */
export function ensureSiteClientCode() {
  let clientCode = Cookie.get(SITE_CLIENT_CODE_COOKIE);
  if (!clientCode || clientCode.length !== 32) {
    clientCode = Date.now() + generateNonceStr(19);
    Cookie.set(SITE_CLIENT_CODE_COOKIE, clientCode);
  }
  syncSdkClientCodeStorage(clientCode);
  return clientCode;
}

export function syncSdkClientCodeStorage(clientCode) {
  if (typeof window === "undefined" || !clientCode || !window.localStorage) return;
  try {
    window.localStorage.setItem(BEHAVIOR_TRACKER_CLIENT_CODE_KEY, String(clientCode));
  } catch (err) {
    // ignore
  }
}

export function syncQueueEventClientCode(event, clientCode) {
  if (!event || !clientCode) return event;
  if (event.client_code === clientCode && event.distinct_id === clientCode) return event;
  return {
    ...event,
    client_code: clientCode,
    distinct_id: clientCode,
  };
}
